import { create } from 'zustand';
import {
  TempBadgeModalState,
  TempBadgeModalOpenValue,
  TempBadgeModalUpdateValue,
  TempBadgingStep,
} from 'containers/jobsite/tabs/jobsiteTempBadges/modals/tempBadgeModal/types';

const initialState: TempBadgeModalState = {
  isOpen: false,
  badgingStep: null,
  prevBadgingStep: null,
  tempBadge: null,
  modalAction: null,
  reassignBadgeState: null,
  workerCardIdToReactivate: null,
  expirationDate: null,
  badgesToDeactivate: null,
  lastUsedPrinterOption: null,
};

const badgingStepByAction: Record<
  TempBadgeModalOpenValue['modalAction'],
  TempBadgingStep
> = {
  createAndPrint: TempBadgingStep.CreateAndPrint,
  reprint: TempBadgingStep.Reprint,
  register: TempBadgingStep.Register,
  reactivate: TempBadgingStep.Reactivate,
  assign: TempBadgingStep.Assign,
};

interface TempBadgeModalStore extends TempBadgeModalState {
  openModal: (modalValue: TempBadgeModalOpenValue) => void;
  closeModal: () => void;
  resetModalState: () => void;
  updateModalState: (updateValue: TempBadgeModalUpdateValue) => void;
}

export const useTempBadgeModal = create<TempBadgeModalStore>((set) => ({
  ...initialState,

  openModal: (tempBadgeModalValue: TempBadgeModalOpenValue): void => {
    const { tempBadge, modalAction } = tempBadgeModalValue;
    set((state) => ({
      isOpen: true,
      tempBadge,
      modalAction,
      prevBadgingStep: state.badgingStep,
      badgingStep: badgingStepByAction[modalAction],
    }));
  },

  closeModal: (): void => set({ isOpen: false }),

  resetModalState: (): void => set(initialState),

  updateModalState: (updateValue: TempBadgeModalUpdateValue): void => {
    set((state) => {
      return {
        ...updateValue,
        // Only update prevBadgingStep if badgingStep is being updated
        ...(updateValue.badgingStep !== undefined
          ? { prevBadgingStep: state.badgingStep }
          : undefined),
      };
    });
  },
}));
